<template>
  <div>
    <div class="banner">
      <div class="userCon">
        <h1>如何查看用户预约的心理咨询？如何开启心理咨询？</h1>
        <p>根据医生的开放时间可进行预约，在预约时间内可与医生进行视频咨询</p>
      </div>
    </div>
    <div class="content userCon">
      <div class="left">
        <div class="select flex" @click="active=0" :class="{'active':active===0}">
          <img src="../../assets/img/pc.png" alt="" width="38">
          <strong>电脑端</strong>
        </div>
        <div class="select flex" @click="active=1" :class="{'active':active===1}">
          <img src="../../assets/img/mobilePhone.png" alt="" width="38">
          <strong>手机端</strong>
        </div>
      </div>
      <div class="right">
        <template v-if="active==0">
          <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>，即可进入【医生工作室】，在顶部菜单栏中点击<span
              class="orange">【预约管理】</span>
          </p>
          <img src="../../assets/img/docAppointRes_a.png" alt="">
          <p><strong>第二步：</strong>在【预约管理】页面中，找到要进行咨询的预约条目，点击<span class="orange">【前往通话】</span>按钮，进入通话页面
          </p>
          <img src="../../assets/img/docAppointRes_b.png" alt="">
          <p><strong>第三步：</strong>在【通话】页面，点击<span class="orange">【拨号】</span>图标，即可呼叫用户，如用户未就绪，请耐心等待片刻
          </p>
          <img src="../../assets/img/docAppointRes_c.png" alt="">
        </template>
        <template v-else>
          <div class="flex userPh">
            <p><strong>第一步：</strong>登录状态下，在【首页】，点击右上角<span class="orange">【≡】</span>按钮，从右侧弹出菜单弹窗</p>
            <p><strong>第二步：</strong>在【菜单栏】中点击<span class="orange">【预约管理】</span>进入【预约列表】</p>
            <p><strong>第三步：</strong>在【预约列表】中，选择即将咨询的预约条目，并点击<span class="orange">【前往通话】</span>按钮</p>
          </div>
          <img src="../../assets/img/docAppointRes_d.png" alt="">
          <div class="flex userPh">
            <p><strong>第四步：</strong>使用【微信APP】，识别<span class="orange">【心理亦笙】</span>小程序二维码</p>
            <p><strong>第五步：</strong>进入【亦笙工作室】微信小程序中，填写登录信息，点击<span class="orange">【登录】</span>按钮</p>
            <p><strong>第六步：</strong>在【待通话列表】中，点击<span class="orange">【通话】</span>按钮，进入通话页面</p>
          </div>
          <img src="../../assets/img/docAppointRes_e.png" alt="">
          <div class="flex userPh">
            <div><strong>第七步：</strong>在【通话页面】中，点击<span class="orange">【拨号】</span>图标<strong
                class="userPh">【通话状态】</strong></div>
          </div>
          <div class="flex">
            <img src="../../assets/img/docAppointRes_f.png" alt="" width="67%">
            <div class="mt_50 mr_20">
              <div class="mt_20">【视频通话】<br/>进入咨询等待页面后，请耐心等待用户的应答</div>
              <div class="mt_20">【文字聊天】<br/>视频下方有文字聊天框，可发送图片，协助咨询交流</div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "doctorAppoint",
  data() {
    return {active: 0}
  },
  mounted() {
    $(".contentIndex").animate({scrollTop: '0px'}, 800);
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/userRegister';
</style>
